export default __webpack_public_path__ + "static/media/CAL44250.59f54591.jpg";